'use client';

import React from 'react';
import ChatAvatar from './ChatAvatar';
import type { ChatMessageRowProps } from './types';

const DEFAULT_CONTENT_CLASS = {
  user: 'flex flex-col gap-1 min-w-0 max-w-xl items-end',
  assistant: 'flex flex-col gap-1 min-w-0 max-w-xl items-start',
} as const;

const ChatMessageRow: React.FC<ChatMessageRowProps> = ({
  variant,
  showAvatar = true,
  avatarProps,
  children,
  timestamp,
  footer,
  contentClassName,
  'data-testid': testId,
}) => {
  const isUser = variant === 'user';
  const avatar = showAvatar ? (
    <ChatAvatar variant={variant} {...avatarProps} />
  ) : null;

  return (
    <div
      className={`flex items-start gap-3 min-w-0 ${isUser ? 'justify-end' : ''}`}
      data-testid={testId}
    >
      {!isUser && avatar}
      <div className={contentClassName ?? DEFAULT_CONTENT_CLASS[variant]}>
        {children}
        {timestamp && (
          <span className="text-xs text-neutral-400">{timestamp}</span>
        )}
        {footer}
      </div>
      {isUser && avatar}
    </div>
  );
};

export default ChatMessageRow;
